import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  Toolbar,
  Typography,
  Drawer,
} from '@material-ui/core'
import { Menu } from '@material-ui/icons'
import {
  AppBar,
  HeaderSpace,
  IconButton,
  Desktop,
  DrawerContent,
} from './styles'

export default function Header(props) {
  const { title, children } = props
  const [showLeftMenu, setShowLeftMenu] = useState(false)

  const toggleLeftMenu = () => {
    setShowLeftMenu(!showLeftMenu)
  }

  return (
    <>
      <Drawer
        anchor="left"
        open={showLeftMenu}
        onClose={toggleLeftMenu}
      >
        <DrawerContent onClick={toggleLeftMenu}>
          {children}
        </DrawerContent>
      </Drawer>
      <AppBar position="fixed">
        <Toolbar>
          <IconButton onClick={toggleLeftMenu}>
            <Menu />
          </IconButton>
          <Typography variant="h6">
            {title}
          </Typography>
        </Toolbar>
      </AppBar>
      <Desktop>
        {children}
      </Desktop>
      <HeaderSpace />
    </>
  )
}

Header.propTypes = {
  title: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.elementType,
    PropTypes.node,
  ]),
}

Header.defaultProps = {
  title: '',
  children: '',
}
